import React, { useState } from 'react';
import { Card, Table, Button, Badge, Form, Modal, Spinner } from 'react-bootstrap';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import { CME_DIEU_DUONG_API, FILE_MANAGER_API, ACCOUNT_API, SIGNEDHUMAN_API, KYSO_API, BaseGatewayImage, BaseGatewayAuthApi } from '../../../../utils/apiUrl';
import { Get, Post, PostFormData, DeleteSingle } from '../../../../utils/httpProvider';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';
import CMEDieuDuongEventAddEditModal from './CMEDieuDuongEventAddEditModal';
import CMEBienBanFormTab from './CMEBienBanFormTab';
import moment from 'moment';
import { exportToWordPhuLuc2 } from './cmeDieuDuongExportHelper';
import { objectChuKy, objectLoaiKy, objectShowNumber, styleSelectDefault } from '../../../../utils/define';
import { createUrlWithParam } from '../../../../utils/helper';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Document, Page, pdfjs } from 'react-pdf';


pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/js/pdf.worker.min.js`;

const CMEDieuDuongEvent = () => {
    const queryClient = useQueryClient();
    const history = useHistory();
    const location = useLocation();

    // Parse URL search params
    const paramUrl = new URLSearchParams(location.search);
    const initialPage = paramUrl.get('page') != null ? parseInt(paramUrl.get('page'), 10) : 1;
    const initialPageSize = paramUrl.get('size') != null ? parseInt(paramUrl.get('size'), 10) : 20;
    const initialKeyword = paramUrl.get('search') != null ? paramUrl.get('search') : '';

    const [page, setPage] = useState(initialPage);
    const [pageSize, setPageSize] = useState(initialPageSize);
    const [keyword, setKeyword] = useState(initialKeyword);

    const [openAddEditModal, setOpenAddEditModal] = useState(false);
    const [selectedData, setSelectedData] = useState(null);

    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
    const [idWantDelete, setIdWantDelete] = useState('');
    const [deleteName, setDeleteName] = useState('');

    const [openAttendanceModal, setOpenAttendanceModal] = useState(false);
    const [currentEvent, setCurrentEvent] = useState(null);

    const [toggleConfirm, setToggleConfirm] = useState({ show: false, id: null, enabled: false, type: 'checkin' });


    // Sync state with URL when URL changes
    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        const p = params.get('page') != null ? parseInt(params.get('page'), 10) : 1;
        const s = params.get('size') != null ? parseInt(params.get('size'), 10) : 20;
        const kw = params.get('search') != null ? params.get('search') : '';

        if (p !== page) setPage(p);
        if (s !== pageSize) setPageSize(s);
        if (kw !== keyword) setKeyword(kw);
    }, [location.search]);

    const cleanParams = (params) => {
        const result = {};
        Object.entries(params).forEach(([key, value]) => {
            if (value !== null && value !== undefined && value !== '') {
                result[key] = value;
            }
        });
        return result;
    };

    const replaceHistory = (Page, Size, Search) => {
        const rawParams = {
            page: Page,
            size: Size,
            search: Search || null,
        };
        history.replace(
            createUrlWithParam(location.pathname, cleanParams(rawParams))
        );
    };

    // Ensure default params exist in URL on mount
    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('page') == null || params.get('size') == null || params.get('search') == null) {
            replaceHistory(page, pageSize, keyword);
        }
    }, []);

    const changePage = (number) => {
        replaceHistory(number, pageSize, keyword);
    };

    const onChangeShowNumber = (e) => {
        const val = Number(e.target.value);
        replaceHistory(1, val, keyword);
    };

    const onChangeKeyword = (e) => {
        const val = e.target.value;
        replaceHistory(1, pageSize, val);
    };

    // Queries
    const { data: eventsPagingData, isLoading, refetch } = useQuery(
        ['cmeDieuDuongEventsPaging', keyword, page, pageSize],
        () => Get(`${CME_DIEU_DUONG_API.GET_PAGING}?keyword=${keyword}&pageIndex=${page}&pageSize=${pageSize}`),
        { keepPreviousData: true }
    );

    const deleteMutation = useMutation(async (id) => {
        const res = await DeleteSingle(CME_DIEU_DUONG_API.DELETE, id);
        if (!res.ok) {
            const text = await res.text();
            let errorData;
            try {
                errorData = JSON.parse(text);
            } catch (e) {
                errorData = { message: text };
            }
            throw errorData;
        }
        return res;
    });
    const toggleCheckinMutation = useMutation(({ id, enabled }) => Post(`${CME_DIEU_DUONG_API.TOGGLE_CHECKIN}/${id}`, null, enabled));
    const toggleCheckoutMutation = useMutation(({ id, enabled }) => Post(`${CME_DIEU_DUONG_API.TOGGLE_CHECKOUT}/${id}`, null, enabled));

    const eventList = eventsPagingData?.data?.$values || eventsPagingData?.data || eventsPagingData?.Data?.$values || eventsPagingData?.Data || [];
    const totalRecords = eventsPagingData?.totalRecords || eventsPagingData?.TotalRecords || 0;

    const handleAdd = () => {
        setSelectedData(null);
        setOpenAddEditModal(true);
    };

    const handleEdit = (item) => {
        setSelectedData(item);
        setOpenAddEditModal(true);
    };

    const handleDelete = (item) => {
        setIdWantDelete(item.id);
        setDeleteName(item.tenKhoaDaoTao);
        setOpenConfirmDeleteModal(true);
    };

    const acceptDelete = () => {
        deleteMutation.mutate(idWantDelete, {
            onSuccess: () => {
                toast.success("Xóa khóa đào tạo thành công.");
                refetch();
                setOpenConfirmDeleteModal(false);
            },
            onError: (err) => {
                toast.error(err?.message || "Lỗi khi xóa.");
            }
        });
    };

    const handleToggleCheckin = (id, enabled) => {
        toggleCheckinMutation.mutate({ id, enabled }, {
            onSuccess: () => {
                toast.success(enabled ? "Đã bật điểm danh tham gia điều dưỡng." : "Đã tắt điểm danh tham gia.");
                refetch();
            }
        });
    };

    const handleToggleCheckout = (id, enabled) => {
        toggleCheckoutMutation.mutate({ id, enabled }, {
            onSuccess: () => {
                toast.success(enabled ? "Đã bật điểm danh kết thúc điều dưỡng." : "Đã tắt điểm danh kết thúc.");
                refetch();
            }
        });
    };

    return (
        <div className="container-fluid">
            <Card className="mb-4 shadow-sm border-0">
                <Card.Header className="bg-white border-bottom d-flex justify-content-between align-items-center py-3">
                    <h5 className="mb-0 text-primary font-weight-bold">
                        <i className="fas fa-user-nurse mr-2"></i>CME Điều dưỡng - Quản lý sinh hoạt & Đào tạo
                    </h5>
                    <Button variant="primary" size="sm" onClick={handleAdd} className="shadow-sm">
                        <i className="fas fa-plus mr-1"></i>Tạo khóa đào tạo mới
                    </Button>
                </Card.Header>
                <Card.Body>
                    <div className="row mb-4">
                        <div className="col-md-6">
                            <Form.Control
                                type="text"
                                placeholder="Tìm kiếm tên khóa học/hoạt động..."
                                value={keyword}
                                onChange={onChangeKeyword}
                            />
                        </div>
                    </div>

                    <div className="table-responsive">
                        <Table hover className="align-middle">
                            <thead className="bg-light text-muted text-uppercase" style={{ fontSize: '0.8rem' }}>
                                <tr>
                                    <th style={{ width: '50px' }}>STT</th>
                                    <th>Tên Khóa đào tạo / Hoạt động</th>
                                    <th style={{ width: '180px' }}>Thời gian</th>
                                    <th style={{ width: '100px' }}>Số giờ CME</th>
                                    <th style={{ width: '220px' }}>Điểm danh tham gia</th>
                                    <th style={{ width: '220px' }}>Điểm danh kết thúc</th>
                                    <th style={{ width: '120px' }}>Trạng thái</th>
                                    <th style={{ width: '200px' }} className="text-center">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan={8} className="text-center py-4">Đang tải dữ liệu...</td></tr>
                                ) : eventList.length === 0 ? (
                                    <tr><td colSpan={8} className="text-center py-4 text-muted">Chưa có khóa học nào.</td></tr>
                                ) : (
                                    eventList.map((item, idx) => (
                                        <tr key={item.id}>
                                            <td>{(page - 1) * pageSize + idx + 1}</td>
                                            <td>
                                                <div className="font-weight-bold text-dark">{item.tenKhoaDaoTao}</div>
                                                <small className="text-muted"><i className="fas fa-map-marker-alt mr-1"></i>{item.diaDiem || 'N/A'}</small>
                                            </td>
                                            <td>
                                                <div style={{ fontSize: '0.85rem' }}>
                                                    <div>Từ: {moment(item.tuNgay).format('DD/MM/YYYY')}</div>
                                                    <div>Đến: {moment(item.denNgay).format('DD/MM/YYYY')}</div>
                                                </div>
                                            </td>
                                            <td className="text-center font-weight-bold">{item.soGioTinChi}h</td>
                                            <td>
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`checkinSwitch-${item.id}`}
                                                        checked={item.choPhepDiemDanhBatDau}
                                                        // Thay vì gọi handleToggleCheckin ngay, ta mở modal xác nhận:
                                                        onChange={(e) => setToggleConfirm({
                                                            show: true,
                                                            id: item.id,
                                                            enabled: e.target.checked,
                                                            type: 'checkin'
                                                        })}

                                                    />
                                                    <label className="custom-control-label font-weight-bold" htmlFor={`checkinSwitch-${item.id}`}>
                                                        {item.choPhepDiemDanhBatDau ? "ĐANG MỞ CHỜ CHECK-IN" : "ĐÃ TẮT"}
                                                    </label>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="custom-control-input"
                                                        id={`checkoutSwitch-${item.id}`}
                                                        checked={item.choPhepDiemDanhKetThuc}
                                                        onChange={(e) => handleToggleCheckout(item.id, e.target.checked)}
                                                    />
                                                    <label className="custom-control-label font-weight-bold" htmlFor={`checkoutSwitch-${item.id}`}>
                                                        {item.choPhepDiemDanhKetThuc ? "ĐANG MỞ CHỜ CHECK-OUT" : "ĐÃ TẮT"}
                                                    </label>
                                                </div>
                                            </td>
                                            <td>
                                                {item.trangThai === 0 && <Badge variant="secondary">Đã thông báo</Badge>}
                                                {item.trangThai === 1 && <Badge variant="warning text-white">Đang diễn ra</Badge>}
                                                {item.trangThai === 2 && <Badge variant="success">Đã kết thúc</Badge>}
                                            </td>
                                            <td className="text-center">
                                                <Button
                                                    variant="outline-info"
                                                    size="sm"
                                                    className="mr-1"
                                                    onClick={() => {
                                                        setCurrentEvent(item);
                                                        setOpenAttendanceModal(true);
                                                    }}
                                                >
                                                    <i className="fas fa-list mr-1"></i>Điểm danh
                                                </Button>
                                                <Button variant="link" size="sm" className="text-info p-0 mr-2" onClick={() => handleEdit(item)}>Sửa</Button>
                                                <Button variant="link" size="sm" className="text-danger p-0" onClick={() => handleDelete(item)}>Xóa</Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </Table>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <Form.Control as="select" value={pageSize} onChange={onChangeShowNumber} style={{ width: '80px' }}>
                            {objectShowNumber.map(opt => <option key={opt.value} value={opt.value}>{opt.text}</option>)}
                        </Form.Control>
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={pageSize}
                            totalItemsCount={totalRecords}
                            pageRangeDisplayed={5}
                            onChange={changePage}
                            itemClass="page-item"
                            linkClass="page-link"
                        />
                    </div>
                </Card.Body>
            </Card>

            <ConfirmModal
                isOpen={openConfirmDeleteModal}
                confirmType="confirm"
                labelAccept="Xóa"
                handleAccept={acceptDelete}
                handleCancel={() => setOpenConfirmDeleteModal(false)}
                content={`Bạn có chắc chắn muốn xóa khóa học: "${deleteName}"?`}
            />

            <ConfirmModal
                isOpen={toggleConfirm.show}
                confirmType="confirm"
                labelAccept="Đồng ý"
                handleAccept={() => {
                    if (toggleConfirm.type === 'checkin') {
                        handleToggleCheckin(toggleConfirm.id, toggleConfirm.enabled);
                    } else {
                        handleToggleCheckout(toggleConfirm.id, toggleConfirm.enabled);
                    }
                    setToggleConfirm({ show: false, id: null, enabled: false, type: 'checkin' });
                }}
                handleCancel={() => setToggleConfirm({ show: false, id: null, enabled: false, type: 'checkin' })}
                content={`Bạn có chắc chắn muốn ${toggleConfirm.enabled ? "BẬT" : "TẮT"} điểm danh này?`}
            />


            <CMEDieuDuongEventAddEditModal
                isOpen={openAddEditModal}
                handleClose={() => setOpenAddEditModal(false)}
                data={selectedData}
                refetch={refetch}
            />

            {openAttendanceModal && currentEvent && (
                <AttendanceDetailModal
                    isOpen={openAttendanceModal}
                    handleClose={() => setOpenAttendanceModal(false)}
                    eventData={currentEvent}
                />
            )}
        </div>
    );
};

// Sub-component: Attendance checklist & Step 1 Approval Modal
const AttendanceDetailModal = ({ isOpen, handleClose, eventData }) => {
    const queryClient = useQueryClient();
    const [selectedIds, setSelectedIds] = useState([]);
    const [minhChungUrl, setMinhChungUrl] = useState('');
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [isSavingList, setIsSavingList] = useState(false);
    const [submittingStep1, setSubmittingStep1] = useState(false);
    const [isResettingFile, setIsResettingFile] = useState(false);
    const [unitMap, setUnitMap] = useState({});
    const [userMap, setUserMap] = useState({});
    const [isExporting, setIsExporting] = useState(false);

    const [downloadUrl, setDownloadUrl] = useState('');
    const [activeTab, setActiveTab] = useState('minutes'); // 'minutes' or 'attendance'
    const hasLocalFileActionRef = React.useRef(false);
    const isFetchingRef = React.useRef(false);

    // Search state
    const [keyword, setKeyword] = useState('');

    // Pagination state
    const [modalPageIndex, setModalPageIndex] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    // Reset pagination when keyword, event, or modal state changes
    React.useEffect(() => {
        setModalPageIndex(1);
        setTotalRecords(0);
    }, [keyword, isOpen, eventData?.id]);

    const { data: list, isLoading, refetch } = useQuery(
        ['cmeAttendanceList', eventData?.id, modalPageIndex],
        () => Get(`${CME_DIEU_DUONG_API.GET_ATTENDANCE}/${eventData?.id}?pageIndex=${modalPageIndex}&pageSize=40`),
        { enabled: !!eventData?.id && isOpen, keepPreviousData: true }
    );

    // Query lấy toàn bộ danh sách điểm danh (không phân trang) để thống kê và xuất phụ lục
    const { data: allListRes, refetch: refetchAllList } = useQuery(
        ['cmeAttendanceListAll', eventData?.id],
        () => Get(`${CME_DIEU_DUONG_API.GET_ATTENDANCE}/${eventData?.id}?pageIndex=1&pageSize=100000`),
        { enabled: !!eventData?.id && isOpen }
    );

    const allListItems = React.useMemo(() => {
        if (!allListRes) return [];
        return allListRes.data?.$values || allListRes.data || allListRes.Data?.$values || allListRes.Data || [];
    }, [allListRes]);

    const { data: eventDetail } = useQuery(
        ['cmeDieuDuongEventFileState', eventData?.id],
        () => Get(`${CME_DIEU_DUONG_API.GET_BY_ID}/${eventData?.id}`),
        { enabled: !!eventData?.id && isOpen }
    );

    const { data: bienBanDetail } = useQuery(
        ['cmeBienBanDetailFileState', eventData?.id],
        () => Get(`${CME_DIEU_DUONG_API.GET_BIEN_BAN}/${eventData?.id}`),
        { enabled: !!eventData?.id && isOpen }
    );

    const currentEventState = eventDetail || eventData;

    // Extract list items from list response
    const currentListItems = React.useMemo(() => {
        if (!list) return [];
        const items = list.data?.$values || list.data || list.Data?.$values || list.Data || [];
        return items;
    }, [list]);

    // Sync totalRecords from API response — must be in useEffect, not useMemo (no side-effects in memos)
    React.useEffect(() => {
        if (!list) return;
        const total = list.totalRecords || list.TotalRecords || 0;
        setTotalRecords(total);
    }, [list]);

    // Apply Client-side filtering & sorting on current page list for seamless UI experience
    const filteredAndSortedList = React.useMemo(() => {
        let result = Array.isArray(currentListItems) ? [...currentListItems] : [];

        if (keyword.trim()) {
            const kw = keyword.trim().toLowerCase();
            result = result.filter(item => {
                const user = userMap[item.userId];
                const unit = unitMap[item.userId];
                const fullName = user?.fullName?.toLowerCase() || '';
                const username = user?.username?.toLowerCase() || '';
                const unitCode = unit?.code?.toLowerCase() || '';
                return fullName.includes(kw) || username.includes(kw) || unitCode.includes(kw);
            });
        }

        return result.sort((a, b) => {
            const unitA = unitMap[a.userId];
            const unitB = unitMap[b.userId];
            const codeA = unitA ? unitA.code : '';
            const codeB = unitB ? unitB.code : '';
            return codeA.localeCompare(codeB, 'vi');
        });
    }, [currentListItems, unitMap, userMap, keyword]);

    const visibleRecords = filteredAndSortedList || [];

    const hasSavedItems = React.useMemo(() => {
        return Array.isArray(currentListItems) && currentListItems.some(x => x.trangThaiDuyet === 4 || x.trangThaiDuyet === 1 || x.trangThaiDuyet === 3);
    }, [currentListItems]);

    // Generate a stable key for visible user IDs to prevent reference loop in useEffect
    const visibleUserIdsString = React.useMemo(() => {
        if (!Array.isArray(visibleRecords)) return '';
        return visibleRecords.map(x => x?.userId).filter(Boolean).join(',');
    }, [visibleRecords]);

    // Batch resolve user unit codes and account info (for search/sorting)
    React.useEffect(() => {
        const fetchDetails = async () => {
            if (!Array.isArray(visibleRecords) || visibleRecords.length === 0) return;
            // Only fetch userIds that do not exist in userMap or unitMap
            // Use filter(Boolean) first to remove any null/undefined userId entries
            const targetUserIds = visibleRecords
                .map(x => x?.userId)
                .filter(Boolean)
                .filter(id => !unitMap[id.toString()] || !userMap[id.toString()]);

            if (targetUserIds.length === 0) return;

            const ssoParams = new URLSearchParams({ PageIndex: 1, PageSize: 50 });
            targetUserIds.forEach(id => ssoParams.append('LstAccountId', id));

            const dungChungParams = new URLSearchParams({ PageIndex: 1, PageSize: 50 });
            targetUserIds.forEach(id => dungChungParams.append('LstAccountId', id));

            // Set placeholder to prevent duplicate instant requests before API responds
            const tempUsers = { ...userMap };
            const tempUnits = { ...unitMap };
            targetUserIds.forEach(id => {
                const idStr = id.toString();
                if (!tempUsers[idStr]) tempUsers[idStr] = { fullName: 'Đang tải...', username: '' };
                if (!tempUnits[idStr]) tempUnits[idStr] = { code: '...' };
            });
            setUserMap(tempUsers);
            setUnitMap(tempUnits);

            try {
                // Do NOT destructure directly to avoid 'z is not iterable' error
                // when Promise.all returns unexpected value (e.g. on reload/session expire)
                const results = await Promise.all([
                    Get(`${BaseGatewayAuthApi}/Account/GetAllPagingNotMenu?${ssoParams.toString()}`),
                    Get(`${ACCOUNT_API.GET_PAGING_ACCOUNT_FROM_APP_DUNGCHUNG}?${dungChungParams.toString()}`)
                ]);

                if (!Array.isArray(results) || results.length < 2) return;
                const [accountRes, unitRes] = results;

                const accounts = accountRes?.data?.$values || accountRes?.data || accountRes?.Data?.$values || accountRes?.Data || [];
                const units = unitRes?.data?.$values || unitRes?.data || unitRes?.Data?.$values || unitRes?.Data || [];

                const finalUsers = { ...tempUsers };
                const finalUnits = { ...tempUnits };

                accounts.forEach(acc => {
                    const authInfo = acc.accountAuthInfo || acc.AccountAuthInfo || acc;
                    const fullName = [
                        authInfo?.lastName || authInfo?.LastName,
                        authInfo?.middleName || authInfo?.MiddleName,
                        authInfo?.firstName || authInfo?.FirstName
                    ].filter(Boolean).join(' ') || 'Chưa cập nhật';
                    const username = acc.username || acc.Username || '';
                    const uId = acc.id || acc.Id;
                    if (uId) {
                        finalUsers[uId.toString()] = { fullName, username };
                        queryClient.setQueryData(['accountInfo', uId.toString()], acc);
                    }
                });

                units.forEach(u => {
                    const donVis = u.donVis || u.DonVis?.$values || u.DonVis || [];
                    const unitObj = donVis[0];
                    const id = unitObj ? (unitObj.id || unitObj.Id || null) : null;
                    const code = unitObj
                        ? (unitObj.maDonVi || unitObj.MaDonVi || '-')
                        : '-';
                    const name = unitObj
                        ? (unitObj.tenDonVi || unitObj.TenDonVi || '-')
                        : '-';
                    const uId = u.accountId || u.AccountId;
                    if (uId) {
                        finalUnits[uId.toString()] = { id, code, name };
                    }
                });

                // Fallback for any target IDs that were not returned by APIs
                targetUserIds.forEach(id => {
                    const idStr = id.toString();
                    if (finalUsers[idStr]?.fullName === 'Đang tải...') {
                        finalUsers[idStr] = { fullName: 'Chưa cập nhật', username: '' };
                    }
                    if (finalUnits[idStr]?.code === '...') {
                        finalUnits[idStr] = { id: null, code: '-', name: '-' };
                    }
                });

                setUserMap(finalUsers);
                setUnitMap(finalUnits);

                // Tự động lưu ngầm thông tin khoa bị thiếu của học viên cũ vào DB mà KHÔNG THAY ĐỔI TRẠNG THÁI DUYỆT
                const missingPayload = visibleRecords
                    .filter(x => !x.maDonVi || x.maDonVi === '-' || x.maDonVi.trim() === '')
                    .map(item => {
                        const unit = finalUnits[item?.userId?.toString()];
                        if (unit && unit.code && unit.code !== '-' && unit.code !== '...') {
                            return {
                                diemDanhId: item.id,
                                donViId: unit.id || null,
                                maDonVi: unit.code,
                                tenDonVi: unit.name || null
                            };
                        }
                        return null;
                    })
                    .filter(Boolean);

                if (missingPayload.length > 0 && eventData?.id) {
                    Post(`${CME_DIEU_DUONG_API.SYNC_UNITS}/${eventData.id}`, null, missingPayload)
                        .then(() => {
                            console.log(`[Auto-Sync] Tự động đồng bộ mã khoa cho ${missingPayload.length} học viên cũ thành công.`);
                            if (typeof refetch === 'function') refetch();
                            if (typeof refetchAllList === 'function') refetchAllList();
                        })
                        .catch(err => {
                            console.error("[Auto-Sync] Lỗi tự động đồng bộ đơn vị:", err);
                        });
                }


            } catch (e) {
                console.error("Lỗi khi batch fetch chi tiết user trong AttendanceDetailModal:", e);
                // Rollback placeholder to default on error so UI does not stay stuck at 'Đang tải...'
                const rollbackUsers = { ...userMap };
                const rollbackUnits = { ...unitMap };
                targetUserIds.forEach(id => {
                    const idStr = id.toString();
                    if (rollbackUsers[idStr]?.fullName === 'Đang tải...') rollbackUsers[idStr] = { fullName: '-', username: '' };
                    if (rollbackUnits[idStr]?.code === '...') rollbackUnits[idStr] = { id: null, code: '-', name: '-' };
                });
                setUserMap(rollbackUsers);
                setUnitMap(rollbackUnits);
            }
        };
        fetchDetails();
    }, [visibleUserIdsString]);

    const handleSelectAll = (checked) => {
        const activeIds = filteredAndSortedList.filter(x => x.trangThaiDuyet === 0).map(x => x.id);
        const lockedIds = currentListItems.filter(x => x.trangThaiDuyet === 4 || x.trangThaiDuyet === 1 || x.trangThaiDuyet === 3).map(x => x.id);
        if (checked) {
            setSelectedIds(prev => [...new Set([...prev, ...activeIds])]);
        } else {
            setSelectedIds(prev => prev.filter(id => !activeIds.includes(id) || lockedIds.includes(id)));
        }
    };

    const handleSelectOne = (id, checked) => {
        const item = currentListItems.find(x => x.id === id);
        if (item && (item.trangThaiDuyet === 4 || item.trangThaiDuyet === 1 || item.trangThaiDuyet === 3)) {
            return; // Locked item cannot be deselected or changed
        }
        if (checked) {
            setSelectedIds(prev => [...prev, id]);
        } else {
            setSelectedIds(prev => prev.filter(x => x !== id));
        }
    };

    const resolveSignedPdfUrl = (url) => {
        if (!url) return '';
        if (url.startsWith('http')) return url;
        return `${BaseGatewayImage}${url.startsWith('/') ? '' : '/'}${url}`;
    };

    const getFileNameFromUrl = (url) => {
        const path = (url || '').split('?')[0];
        return path.split('/').pop() || `minh-chung-${moment().format('YYYYMMDDHHmmss')}.pdf`;
    };

    const deleteSignedTempFile = async (url) => {
        if (!url) return;

        try {
            await DeleteSingle(FILE_MANAGER_API.DELETE_FILE_PATH, null, {
                filePath: url
            });
        } catch (err) {
            console.warn('Không xóa được file tạm fileSign.', err);
        }
    };

    const handleUploadMinhChung = async (signatureOptions = objectChuKy) => {
        const requiredSignatures = Array.isArray(signatureOptions) ? signatureOptions : objectChuKy;
        if (!downloadUrl) {
            toast.warning("Vui lòng ký số để tạo file PDF trước khi tải minh chứng.");
            return;
        }

        if (!requiredSignatures.every(item => signedFields.includes(item.value))) {
            toast.warning("Vui lòng ký đủ 2 chữ ký trước khi lấy PDF đã ký.");
            return;
        }

        setIsUploadingFile(true);
        try {
            const signedPdfRes = await fetch(resolveSignedPdfUrl(downloadUrl));
            if (!signedPdfRes.ok) {
                throw new Error('Không tải được file PDF đã ký.');
            }

            const blob = await signedPdfRes.blob();
            const file = new File([blob], getFileNameFromUrl(downloadUrl), { type: blob.type || 'application/pdf' });
            const formData = new FormData();
            formData.append('file', file);

            const res = await PostFormData(FILE_MANAGER_API.UPLOAD, formData);
            const uploadedFile = Array.isArray(res) ? res[0] : res;
            const fileUrl = uploadedFile?.filePath || uploadedFile?.FilePath || uploadedFile?.path || uploadedFile?.fileUrl || res?.path || res?.fileUrl;
            if (fileUrl) {
                hasLocalFileActionRef.current = true;
                setMinhChungUrl(fileUrl);
                toast.success("Tải file minh chứng từ PDF đã ký thành công!");
                await persistPhuLuc2FileState({ minhChungUrl: fileUrl });
            } else {
                toast.error("Không nhận được đường dẫn file từ Server.");
            }
        } catch (err) {
            toast.error(err?.message || "Lỗi khi upload file minh chứng.");
        } finally {
            setIsUploadingFile(false);
        }
    };

    const triggerRefetch = () => {
        queryClient.invalidateQueries(['cmeAttendanceList']);
        queryClient.invalidateQueries(['cmeAttendanceListAll']);
    };

    const handleSaveList = async () => {
        setIsSavingList(true);
        try {
            // Lấy danh sách các bản ghi đã lưu từ trước để gộp vào chung payload, 
            // tránh bị backend hiểu nhầm là đã bỏ chọn và reset về 0
            const alreadySavedIds = allListItems.filter(x => x.trangThaiDuyet === 4).map(x => x.id);
            const combinedIds = [...new Set([...selectedIds, ...alreadySavedIds])];

            const payload = combinedIds.map(id => {
                const item = allListItems.find(x => x.id === id);
                const unit = unitMap[item?.userId];
                const code = (unit?.code && unit.code !== '-' && unit.code !== '...') ? unit.code : (item?.maDonVi || null);
                const name = (unit?.name && unit.name !== '-' && unit.name !== '...') ? unit.name : (item?.tenDonVi || null);
                const donViId = unit?.id || item?.donViId || null;
                return {
                    diemDanhId: id,
                    donViId: donViId,
                    maDonVi: code,
                    tenDonVi: name
                };
            });
            await Post(`${CME_DIEU_DUONG_API.SAVE_LIST}/${eventData.id}`, null, payload);
            toast.success("Lưu danh sách thành công!");
            triggerRefetch();
        } catch (err) {
            toast.error(err?.message || "Lỗi khi lưu danh sách.");
        } finally {
            setIsSavingList(false);
        }
    };


    const handleSubmitStep1 = async () => {
        const savedIds = currentListItems.filter(x => x.trangThaiDuyet === 4).map(x => x.id);
        if (savedIds.length === 0) {
            toast.error("Vui lòng lưu danh sách học viên trước khi duyệt.");
            return;
        }
        if (!minhChungUrl) {
            toast.error("Vui lòng tải lên file minh chứng trước khi duyệt.");
            return;
        }
        if (!bienBanDetail?.bienBanUrl) {
            toast.error("Vui lòng hoàn tất và ký số biên bản sinh hoạt trước khi duyệt.");
            return;
        }

        if (!hasAllRequiredSignatures) {
            toast.error("Vui lòng ký đủ 2 chữ ký trước khi duyệt.");
            return;
        }

        setSubmittingStep1(true);
        try {
            const diemDanhUnits = savedIds.map(id => {
                const item = allListItems.find(x => x.id === id);
                const unit = unitMap[item?.userId];
                const code = (unit?.code && unit.code !== '-' && unit.code !== '...') ? unit.code : (item?.maDonVi || null);
                const name = (unit?.name && unit.name !== '-' && unit.name !== '...') ? unit.name : (item?.tenDonVi || null);
                const donViId = unit?.id || item?.donViId || null;
                return {
                    diemDanhId: id,
                    donViId: donViId,
                    maDonVi: code,
                    tenDonVi: name
                };
            });
            await Post(`${CME_DIEU_DUONG_API.APPROVE_STEP1}/${eventData.id}`, null, {
                diemDanhUnits: diemDanhUnits,
                minhChungUrl: minhChungUrl,
                bienBanUrl: bienBanDetail?.bienBanUrl || null,
                isApproveAll: false
            });
            toast.success("Duyệt danh sách Bước 1 thành công!");
            // Reset modalPageIndex to reload from page 1 on success
            setModalPageIndex(1);
            triggerRefetch();
        } catch (err) {
            toast.error(err?.message || "Lỗi khi duyệt.");
        } finally {
            setSubmittingStep1(false);
        }
    };

    const handleApproveAllStep1 = async () => {
        const totalSavedCount = allListItems.filter(x => x.trangThaiDuyet === 4).length;
        if (totalSavedCount === 0) {
            toast.error("Không có học viên nào ở trạng thái 'Đã lưu (Đề xuất)' để duyệt toàn bộ.");
            return;
        }
        if (!minhChungUrl) {
            toast.error("Vui lòng tải lên file minh chứng trước khi duyệt.");
            return;
        }
        if (!hasAllRequiredSignatures) {
            toast.error("Vui lòng ký đủ 2 chữ ký trước khi duyệt.");
            return;
        }

        const accepted = window.confirm(`Bạn có chắc chắn muốn duyệt toàn bộ ${totalSavedCount} học viên đang có đề xuất?`);
        if (!accepted) return;

        setSubmittingStep1(true);
        try {
            await Post(`${CME_DIEU_DUONG_API.APPROVE_STEP1}/${eventData.id}`, null, {
                diemDanhUnits: [],
                minhChungUrl: minhChungUrl,
                bienBanUrl: bienBanDetail?.bienBanUrl || null,
                isApproveAll: true
            });
            toast.success(`Đã duyệt toàn bộ ${totalSavedCount} học viên Bước 1 thành công!`);
            setModalPageIndex(1);
            triggerRefetch();
        } catch (err) {
            toast.error(err?.message || "Lỗi khi duyệt toàn bộ.");
        } finally {
            setSubmittingStep1(false);
        }
    };

    const [docxFileId, setDocxFileId] = useState('');
    const [docxFilePath, setDocxFilePath] = useState('');

    const [filePathAbsolute, setFilePathAbsolute] = useState('');
    const [openBulkActionModal, setOpenBulkActionModal] = useState(false);
    const [bulkUsername, setBulkUsername] = useState('');
    const [bulkPassword, setBulkPassword] = useState('');
    const [isSigning, setIsSigning] = useState(false);

    const [signedFields, setSignedFields] = useState([]);
    const [openPdfViewer, setOpenPdfViewer] = useState(false);

    const [numPages, setNumPages] = useState(0);
    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    const getFileNameFromPath = (path) => {
        if (!path) return '';
        const parts = path.split(/[\\/]/);
        return parts[parts.length - 1] || path;
    };

    const getRelativeFilePath = (absolutePath) => {
        if (!absolutePath) return '';

        const normalizedPath = absolutePath.replace(/\\/g, '/');
        const match = normalizedPath.match(/(?:^|\/)(files|fileSign|cachedDocument)\/(.+)$/i);
        if (match) {
            return `${match[1]}/${match[2]}`;
        }

        return normalizedPath.split('/').pop() || normalizedPath;
    };

    const parseSignedFields = (value) => {
        if (!value) return [];
        if (Array.isArray(value)) return value.filter(Boolean);
        return String(value).split(',').map(x => x.trim()).filter(Boolean);
    };

    const hasAllRequiredSignatures = objectChuKy.every(x => signedFields.includes(x.value));

    const persistPhuLuc2FileState = async (nextState = {}) => {
        if (!eventData?.id) return;

        await Post(`${CME_DIEU_DUONG_API.SAVE_PHU_LUC_2_FILE_STATE}/${eventData.id}`, null, {
            filePathAbsolute: nextState.filePathAbsolute ?? filePathAbsolute,
            downloadUrl: nextState.downloadUrl ?? downloadUrl,
            signedFields: nextState.signedFields ?? signedFields,
            minhChungUrl: nextState.minhChungUrl ?? minhChungUrl
        });
    };

    React.useEffect(() => {
        if (!isOpen) {
            hasLocalFileActionRef.current = false;
        }
    }, [isOpen, eventData?.id]);

    React.useEffect(() => {
        if (!isOpen || !currentEventState || hasLocalFileActionRef.current) return;

        const savedFilePath = currentEventState.phuLuc2FilePathAbsolute || currentEventState.PhuLuc2FilePathAbsolute || '';
        const savedDownloadUrl = currentEventState.phuLuc2DownloadUrl || currentEventState.PhuLuc2DownloadUrl || '';
        const savedSignedFields = currentEventState.phuLuc2SignedFields || currentEventState.PhuLuc2SignedFields || '';
        const savedMinhChungUrl = currentEventState.phuLuc2MinhChungUrl || currentEventState.PhuLuc2MinhChungUrl || '';

        setFilePathAbsolute(savedFilePath);
        setDownloadUrl(savedDownloadUrl || getRelativeFilePath(savedFilePath));
        setSignedFields(parseSignedFields(savedSignedFields));
        setMinhChungUrl(savedMinhChungUrl);
    }, [isOpen, currentEventState]);

    const handleCloseBulkActionModal = () => {
        setOpenBulkActionModal(false);
        setBulkUsername('');
        setBulkPassword('');
    };

    const [bulkLoaiKy, setBulkLoaiKy] = useState(
        objectLoaiKy && objectLoaiKy.length > 0 ? objectLoaiKy[0].value : ''
    );

    const [bulkChuKy, setBulkChuKy] = useState(
        objectChuKy && objectChuKy.length > 0 ? objectChuKy[0].value : ''
    );

    // Export Word Document (Phụ lục 2)
    const handleExportPhuLuc = async () => {
        // Chỉ lấy những học viên ở trạng thái Đã lưu (Đề xuất) = 4
        const savedRecords = allListItems.filter(x => x.trangThaiDuyet === 4);
        if (savedRecords.length === 0) {
            toast.warning("Chưa có danh sách được lưu (Đề xuất) để xuất phụ lục.");
            return;
        }

        setIsExporting(true);
        try {
            // 1. Tìm các học viên chưa có họ tên trong cache userMap
            const targetUserIds = savedRecords
                .map(x => x.userId)
                .filter(Boolean)
                .map(id => id.toString());

            const missingUserIds = [...new Set(targetUserIds)].filter(idStr =>
                !userMap[idStr] || userMap[idStr].fullName === 'Đang tải...' || userMap[idStr].fullName === '-'
            );

            let finalUserMap = { ...userMap };

            // 2. Nếu thiếu, gọi API tải bổ sung song song bằng Promise.all (chunkSize = 40 để an toàn URL)
            if (missingUserIds.length > 0) {
                const chunkSize = 40;
                const chunks = [];
                for (let i = 0; i < missingUserIds.length; i += chunkSize) {
                    chunks.push(missingUserIds.slice(i, i + chunkSize));
                }

                try {
                    // Tạo danh sách các Promise gọi API song song
                    const promises = chunks.map(chunk => {
                        const ssoParams = new URLSearchParams({ PageIndex: 1, PageSize: 40 });
                        chunk.forEach(id => ssoParams.append('LstAccountId', id));
                        return Get(`${BaseGatewayAuthApi}/Account/GetAllPagingNotMenu?${ssoParams.toString()}`);
                    });

                    // Thực thi tải song song đồng thời
                    const results = await Promise.all(promises);

                    // Duyệt gộp kết quả từ tất cả các chunk trả về
                    results.forEach(accountRes => {
                        const accounts = accountRes?.data?.$values || accountRes?.data || accountRes?.Data?.$values || accountRes?.Data || [];
                        accounts.forEach(acc => {
                            const authInfo = acc.accountAuthInfo || acc.AccountAuthInfo || acc;
                            const fullName = [
                                authInfo?.lastName || authInfo?.LastName,
                                authInfo?.middleName || authInfo?.MiddleName,
                                authInfo?.firstName || authInfo?.FirstName
                            ].filter(Boolean).join(' ') || 'Chưa cập nhật';
                            const username = acc.username || acc.Username || '';
                            const uId = acc.id || acc.Id;
                            if (uId) {
                                finalUserMap[uId.toString()] = { fullName, username };
                            }
                        });
                    });

                    // Đồng bộ ngược lại state chung để tối ưu cho các thao tác chuyển trang tiếp theo
                    setUserMap(finalUserMap);
                } catch (err) {
                    console.error("Lỗi khi tải thông tin song song học viên SSO để xuất phụ lục:", err);
                }
            }

            // 3. Tiến hành xuất file với finalUserMap đầy đủ
            var result = await exportToWordPhuLuc2(savedRecords, currentEventState, docxFilePath, finalUserMap, unitMap);

            if (result) {
                hasLocalFileActionRef.current = true;
                const newDownloadUrl = getRelativeFilePath(result);
                setFilePathAbsolute(result);
                setDownloadUrl(newDownloadUrl);
                setSignedFields([]);
                setMinhChungUrl('');
                await persistPhuLuc2FileState({
                    filePathAbsolute: result,
                    downloadUrl: newDownloadUrl,
                    signedFields: [],
                    minhChungUrl: ''
                });
            }
        } catch (error) {
            toast.error(error?.message || "Lỗi khi xuất Phụ lục 2.");
        } finally {
            setIsExporting(false);
        }
    };

    const handleResetPhuLuc2File = async () => {
        if (!filePathAbsolute && !downloadUrl && !minhChungUrl && signedFields.length === 0) {
            toast.info('Chưa có file để reset.');
            return;
        }

        const accepted = window.confirm('Việc reset file sẽ xóa các bản đã xuất/ký và bắt đầu lại từ đầu. Bạn có chắc chắn?');
        if (!accepted) return;

        setIsResettingFile(true);
        try {
            await Post(`${CME_DIEU_DUONG_API.RESET_PHU_LUC_2_FILE_STATE}/${eventData.id}`, null, {});
            hasLocalFileActionRef.current = true;
            setFilePathAbsolute('');
            setDownloadUrl('');
            setSignedFields([]);
            setMinhChungUrl('');
            setNumPages(0);
            setOpenPdfViewer(false);
            queryClient.invalidateQueries(['cmeDieuDuongEventFileState', eventData?.id]);
            toast.success('Thành công xóa file. Bạn có thể xuất lại Phụ lục 2 từ đầu.');
        } catch (err) {
            toast.error(err?.message || 'Lỗi khi xóa file.');
        } finally {
            setIsResettingFile(false);
        }
    };


    const loadOptionsDocxFile = async (search, loadedOptions, { page }) => {
        const pageSize = 10;
        const res = await Get(FILE_MANAGER_API.GET_PAGING, null, {
            PageIndex: page,
            PageSize: pageSize,
            IsTemplate: true,
            Keyword: search, // pass the input text to filter server-side
            FileType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });

        const data = res.data || [];
        const options = data.map((x) => ({
            label: `${x.filePath}`,
            value: x.id
        }));

        // assume your API returns total count or a flag for more pages
        const hasMore = data.length === pageSize;
        return {
            options,
            hasMore,
            additional: { page: page + 1 }
        };
    };

    const addFunc = useMutation((value) =>
        Post(KYSO_API.KYSO_ONE_FILE_ONE_SIGNATURE, null, value, false, false, true)
    );

    const handleConfirmBulkAction = async () => {
        if (!filePathAbsolute) {
            toast.warning('Vui lòng xuất Phụ lục 2 trước khi ký');
            return;
        }

        if (!bulkUsername || !bulkPassword) {
            toast.warning('Vui lòng nhập username và password');
            return;
        }

        if (signedFields.includes(bulkChuKy)) {
            toast.warning('Ô ký này đã được ký rồi');
            return;
        }

        const nextSignedFields = [...new Set([...signedFields, bulkChuKy])];
        const isFinalSignature = objectChuKy.every(x =>
            nextSignedFields.includes(x.value)
        );

        const model = {
            userName: bulkUsername,
            password: bulkPassword,
            mid: objectLoaiKy.find(x => x.value == bulkLoaiKy)?.value,
            signatureName: bulkChuKy,
            filePathAbsolute,
            filePath: getRelativeFilePath(filePathAbsolute),
            isFinalSignature
        };

        setIsSigning(true);
        try {
            const res = await addFunc.mutateAsync(model);

            if (!res?.success) {
                toast.error(res?.message || 'Ký số thất bại');
                return;
            }

            hasLocalFileActionRef.current = true;
            setSignedFields(nextSignedFields);
            setFilePathAbsolute(res.filePathAbsolute);

            setOpenPdfViewer(true);
            setDownloadUrl(res.downloadUrl);
            await persistPhuLuc2FileState({
                filePathAbsolute: res.filePathAbsolute,
                downloadUrl: res.downloadUrl,
                signedFields: nextSignedFields
            });

            toast.success(
                isFinalSignature
                    ? 'Ký hoàn tất, file đã được lưu vào fileSign.'
                    : 'Ký thành công, file tạm đã được lưu vào cachedDocument.'
            );

            setOpenBulkActionModal(false);
        } catch (error) {
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại!');
        } finally {
            setIsSigning(false);
        }
    };

    const handleOpenBulkActionModal = () => {
        setBulkUsername('');
        setBulkPassword('');
        setOpenBulkActionModal(true);
    };

    return (
        <>
            <Modal show={isOpen} onHide={handleClose} size="xl" backdrop="static" style={{ zIndex: '99999' }}>
                <Modal.Header closeButton className="cme-header" style={{ borderBottom: 'none' }}>
                    <Modal.Title className="text-primary font-weight-bold">
                        <i className="fas fa-list-alt mr-2"></i>Điểm danh & Duyệt danh sách: {eventData?.tenKhoaDaoTao}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Tab Navigation */}
                    <ul className="nav nav-tabs mb-3">
                        <li className="nav-item">
                            <button
                                className={`nav-link btn ${activeTab === 'minutes' ? 'active font-weight-bold text-primary' : 'text-secondary'}`}
                                onClick={() => setActiveTab('minutes')}
                                style={{ borderBottom: activeTab === 'minutes' ? '3px solid #007bff' : 'none' }}
                            >
                                <i className="fas fa-file-alt mr-2"></i>Biên bản sinh hoạt
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className={`nav-link btn ${activeTab === 'attendance' ? 'active font-weight-bold text-primary' : 'text-secondary'}`}
                                onClick={() => setActiveTab('attendance')}
                                style={{ borderBottom: activeTab === 'attendance' ? '3px solid #007bff' : 'none' }}
                            >
                                <i className="fas fa-user-check mr-2"></i>Điểm danh & Duyệt danh sách
                            </button>
                        </li>
                    </ul>

                    {activeTab === 'attendance' ? (
                        <>
                            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center mb-3" style={{ gap: '12px' }}>
                        <div className="d-flex flex-wrap align-items-center" style={{ flex: 1, gap: '8px' }}>
                            <Button
                                variant="outline-primary"
                                size="sm"
                                onClick={handleSaveList}
                                disabled={isSavingList}
                                style={{ borderRadius: '8px', fontWeight: 600 }}
                            >
                                {isSavingList ? <Spinner animation="border" size="sm" /> : <><i className="fas fa-save mr-1"></i>Lưu danh sách</>}
                            </Button>
                            <AsyncPaginate
                                name="docxFileId"
                                id="docxFileId"
                                placeholder="Chọn file docx"
                                value={docxFileId}
                                loadOptions={loadOptionsDocxFile}
                                styles={{
                                    ...styleSelectDefault,
                                    container: (base) => ({
                                        ...base,
                                        minWidth: '220px',
                                        flex: '0 1 280px'
                                    }),
                                    menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 100000
                                    })
                                }}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                isClearable
                                onChange={(selectedOption) => {
                                    setDocxFileId(selectedOption);
                                    setDocxFilePath(selectedOption?.label || '');
                                }}
                                additional={{
                                    page: 1
                                }}
                            />
                            <Button className="modern-btn-success" size="sm" onClick={handleExportPhuLuc} disabled={isExporting}>
                                {isExporting ? <><i className="fas fa-spinner fa-spin mr-1"></i>Đang xuất file...</> : <><i className="fas fa-file-word mr-1"></i>Xuất Phụ lục 2</>}
                            </Button>
                            <button
                                type="button"
                                className="btn btn-danger mr-2"
                                onClick={() => setOpenPdfViewer(true)}
                            >
                                Xem lại file
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger mr-2"
                                onClick={handleOpenBulkActionModal}
                            >
                                Login để ký số
                            </button>
                            <Form.Control
                                type="text"
                                placeholder="Tìm kiếm theo tên, CCCD hoặc mã đơn vị..."
                                value={keyword}
                                onChange={(e) => setKeyword(e.target.value)}
                                size="sm"
                                style={{ borderRadius: '8px', maxWidth: '320px', minWidth: '240px', flex: '1 1 auto' }}
                            />
                            <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={handleResetPhuLuc2File}
                                disabled={isResettingFile || (!filePathAbsolute && !downloadUrl && !minhChungUrl && signedFields.length === 0)}
                                style={{ borderRadius: '8px', fontWeight: 600 }}
                            >
                                {isResettingFile ? <Spinner animation="border" size="sm" /> : <><i className="fas fa-redo mr-1"></i>Reset file</>}
                            </Button>
                        </div>
                        <div className="d-flex flex-wrap align-items-center" style={{ gap: '8px' }}>
                            <Button
                                variant={minhChungUrl ? "success" : "outline-primary"}
                                size="sm"
                                onClick={handleUploadMinhChung}
                                disabled={!downloadUrl || !hasAllRequiredSignatures || isUploadingFile}
                                style={{ borderRadius: '8px', fontWeight: 600 }}
                            >
                                {isUploadingFile ? <Spinner animation="border" size="sm" /> : (minhChungUrl ? "Đã đính kèm" : "Lấy PDF đã ký")}
                            </Button>
                            <Button
                                className="modern-btn-primary"
                                size="sm"
                                onClick={handleSubmitStep1}
                                disabled={!minhChungUrl || !bienBanDetail?.bienBanUrl || !hasSavedItems || !hasAllRequiredSignatures || submittingStep1}
                                style={{ borderRadius: '8px', fontWeight: 600 }}
                            >
                                {submittingStep1 ? <Spinner animation="border" size="sm" /> : `Duyệt B1 (Tích chọn)`}
                            </Button>
                        </div>
                    </div>

                    <div className="table-responsive" style={{ maxHeight: '420px', overflowY: 'auto', border: '1px solid #dee2e6', borderRadius: '8px' }}>
                        <Table hover className="align-middle mb-0 cme-table">
                            <thead className="text-muted text-uppercase" style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 1, fontSize: '0.8rem', borderBottom: '2px solid #dee2e6' }}>
                                <tr>
                                    <th className="text-center" style={{ width: '40px' }}>
                                        <Form.Check
                                            type="checkbox"
                                            onChange={(e) => handleSelectAll(e.target.checked)}
                                            checked={filteredAndSortedList.filter(x => x.trangThaiDuyet === 0).length > 0 && filteredAndSortedList.filter(x => x.trangThaiDuyet === 0).every(x => selectedIds.includes(x.id))}
                                        />
                                    </th>
                                    <th className="text-center" style={{ width: '50px' }}>STT</th>
                                    <th>Số CCCD</th>
                                    <th>Họ và tên</th>
                                    <th>Đơn vị / Khoa</th>
                                    <th className="text-center">Giờ Điểm danh Đến</th>
                                    <th className="text-center">Giờ Điểm danh Về</th>
                                    <th className="text-center" style={{ width: '150px' }}>Trạng thái</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    <tr><td colSpan={8} className="text-center py-4">Đang tải dữ liệu...</td></tr>
                                ) : filteredAndSortedList.length === 0 ? (
                                    <tr><td colSpan={8} className="text-center py-4 text-muted">Không tìm thấy điều dưỡng nào phù hợp.</td></tr>
                                ) : (
                                    visibleRecords.map((item, idx) => {
                                        return (
                                            <tr key={item.id}>
                                                <td className="text-center">
                                                    {item.trangThaiDuyet === 0 ? (
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={selectedIds.includes(item.id)}
                                                            onChange={(e) => handleSelectOne(item.id, e.target.checked)}
                                                        />
                                                    ) : (item.trangThaiDuyet === 4 || item.trangThaiDuyet === 1 || item.trangThaiDuyet === 3) ? (
                                                        <Form.Check
                                                            type="checkbox"
                                                            checked={true}
                                                            disabled={true}
                                                        />
                                                    ) : null}
                                                </td>
                                                <td className="text-center">{(modalPageIndex - 1) * 40 + idx + 1}</td>
                                                <td>
                                                    <span id={`cccd-${item.userId}`} className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>
                                                        {userMap[item.userId]?.username || '-'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span id={`name-${item.userId}`} className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>
                                                        {userMap[item.userId]?.fullName || '-'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span id={`unit-${item.userId}`}>
                                                        {item.maDonVi || unitMap[item.userId]?.code || '-'}
                                                    </span>
                                                </td>
                                                <td className="text-center font-weight-bold text-success">
                                                    {item.thoiGianDen ? moment(item.thoiGianDen).format('HH:mm:ss DD/MM') : '-'}
                                                </td>
                                                <td className="text-center font-weight-bold text-info">
                                                    {item.thoiGianVe ? moment(item.thoiGianVe).format('HH:mm:ss DD/MM') : '-'}
                                                </td>
                                                <td className="text-center">
                                                    {item.trangThaiDuyet === 0 && (
                                                        <span className="badge-status-pending">
                                                            <i className="fas fa-clock mr-1"></i>Chờ duyệt
                                                        </span>
                                                    )}
                                                    {item.trangThaiDuyet === 4 && (
                                                        <span
                                                            className="badge badge-info"
                                                            style={{
                                                                padding: '5px 10px',
                                                                borderRadius: '12px',
                                                                fontSize: '0.75rem',
                                                                backgroundColor: '#e3f2fd',
                                                                color: '#0d47a1',
                                                                fontWeight: 'bold',
                                                                display: 'inline-flex',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            <i className="fas fa-save mr-1"></i>Đã lưu (Đề xuất)
                                                        </span>
                                                    )}
                                                    {item.trangThaiDuyet === 1 && (
                                                        <span className="badge-status-step1">
                                                            <i className="fas fa-check-circle mr-1"></i>Hợp lệ Bước 1
                                                        </span>
                                                    )}
                                                    {item.trangThaiDuyet === 2 && (
                                                        <span className="badge-status-rejected">
                                                            <i className="fas fa-times-circle mr-1"></i>Bị từ chối
                                                        </span>
                                                    )}
                                                    {item.trangThaiDuyet === 3 && (
                                                        <span className="badge-status-approved">
                                                            <i className="fas fa-check-circle mr-1"></i>Đã tích điểm (B2)
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </Table>
                    </div>
                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <span className="small text-muted">Hiển thị {currentListItems.length} / {totalRecords} học viên</span>
                                <Pagination
                                    activePage={modalPageIndex}
                                    itemsCountPerPage={40}
                                    totalItemsCount={totalRecords}
                                    pageRangeDisplayed={5}
                                    onChange={(p) => setModalPageIndex(p)}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                />
                            </div>
                        </>
                    ) : (
                        <CMEBienBanFormTab eventData={eventData} />
                    )}
                </Modal.Body>
                <Modal.Footer style={{ borderTop: 'none' }}>
                    <Button variant="secondary" style={{ borderRadius: '8px', padding: '6px 16px', fontWeight: 600 }} onClick={handleClose}>Đóng</Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={openBulkActionModal}
                onHide={handleCloseBulkActionModal}
                centered
                backdrop="static"
                keyboard={false}
                style={{ zIndex: '99999' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Nhập thông tin xác nhận</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Đường dẫn</Form.Label>
                            <Form.Control
                                type="text"
                                value={getFileNameFromPath(filePathAbsolute)}
                                disabled={true}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Username</Form.Label>
                            <Form.Control
                                type="text"
                                value={bulkUsername}
                                onChange={(e) => setBulkUsername(e.target.value)}
                                placeholder="Nhập username"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                value={bulkPassword}
                                onChange={(e) => setBulkPassword(e.target.value)}
                                placeholder="Nhập password"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Loại ký</Form.Label>
                            <select
                                className="form-control"
                                value={bulkLoaiKy}
                                onChange={(e) => setBulkLoaiKy(e.target.value)}
                            >
                                {objectLoaiKy.map((item, key) => (
                                    <option key={Number(key)} value={item.value}>
                                        {item.text}
                                    </option>
                                ))}
                            </select>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Chức vụ ký</Form.Label>
                            <select
                                className="form-control"
                                value={bulkChuKy}
                                onChange={(e) => setBulkChuKy(e.target.value)}
                            >
                                {objectChuKy.map((item, key) => (
                                    <option
                                        key={Number(key)}
                                        value={item.value}
                                        disabled={signedFields.includes(item.value)}
                                    >
                                        {item.text}{signedFields.includes(item.value) ? ' - Đã ký' : ''}
                                    </option>
                                ))}
                            </select>
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={handleConfirmBulkAction} disabled={isSigning}>
                        {isSigning ? (
                            <><Spinner animation="border" size="sm" className="mr-2" />Đang ký số...</>
                        ) : 'Xác nhận'}
                    </Button>
                    <Button variant="secondary" onClick={handleCloseBulkActionModal} disabled={isSigning}>
                        Hủy
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={openPdfViewer}
                onHide={() => setOpenPdfViewer(false)}
                size="xl"
                centered
                backdrop="static"
                keyboard={false}
                style={{ zIndex: '999999' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Xem file PDF đã ký</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ maxHeight: '75vh', overflow: 'auto', padding: '16px', backgroundColor: '#f8f9fa' }}>
                    <div style={{ minWidth: '1100px', display: 'flex', justifyContent: 'center' }}>
                        <Document
                            file={resolveSignedPdfUrl(downloadUrl || getRelativeFilePath(filePathAbsolute))}
                            onLoadSuccess={onDocumentLoadSuccess}
                            loading="Đang tải PDF..."
                            error="Không tải được PDF"
                        >
                            {Array.from(new Array(numPages || 0), function (_, index) {
                                return (
                                    <Page
                                        key={`page_${index + 1}`}
                                        pageNumber={index + 1}
                                        width={1050}
                                        renderAnnotationLayer={false}
                                        renderTextLayer={false}
                                    />
                                );
                            })}
                        </Document>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setOpenPdfViewer(false)}>
                        Hủy
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CMEDieuDuongEvent;
